<template>
  <div class="modal fade" id="orderHistoryWithComments" tabindex="-1" role="dialog"
       aria-labelledby="orderHistoryWithComments_ModalLabel" style="display: none;">
    <div class="modal-dialog modal-labels" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title"><i class="fa fa-truck mr-5"></i>{{ 'label_history' | translate }}</h4>
        </div>
        <div class="modal-body">
          <div class="direct-chat">
            <div class="box-header">
              <h3 class="box-title"><i class="fa fa-calendar-o mr-5"></i>{{ 'store_ranking' | translate }}</h3>
            </div>
            <div class="box-body">
              <div class="direct-chat-messages">
                <ul class="timeline">
                  <template v-for="t in transitions">
                    <li class="time-label">
                      <span><i class="fa fa-calendar-o mr-5"></i>{{ t.date }}</span>
                    </li>
                    <li v-for="(e, index) in t.transitions">
                      <i :class="[getClass(e.event).icon, getClass(e.event).style]"></i>
                      <div class="timeline-item" :key="e.id">
                        <div class="timeline-header">
                          <span class="text-muted"><i class="fa fa-clock-o mr-5"></i>{{ e.time }}</span>
                          <span :class="getClass(e.event).style">{{ e.event | translate }}</span>
                        </div>
                        <div class="timeline-body" v-if="e.event !== 'approved'">
                          <div class="col-xs-12">
                            <label>{{ 'points' | translate }} : </label>
                            <span name="ranking" type="text">{{e.points}}</span>
                            <span v-show="errors.has(`event-${e.id}.ranking`)"
                                  class="small text-danger">{{ errors.first(`event-${e.id}.ranking`) }}</span>
                          </div>
                          <div class="col-xs-12 mt-10">
                            <label>{{ 'message' | translate }} : </label>
                            <span>{{e.message}}</span>
                            <span v-show="errors.has(`event-${e.id}.message`)"
                                  class="small text-danger">{{ errors.first(`event-${e.id}.message`) }}</span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['transitions', 'main', 'name'],
  data() {
    return {
      show: true,
      isLoading: []
    }
  },
  methods: {
    getClass(e) {
      e = e.replace('_ln', '')
      switch (e) {
        case 'shipped':
          return {icon: 'fa fa-truck', style: 'text-success', btn: 'btn btn-success'}
        case 'initial':
          return {icon: 'fa fa-cloud-download', style: 'text-primary', btn: 'btn btn-primary'}
        case 'approved':
          return {icon: 'fa fa-thumbs-up', style: 'text-info', btn: 'btn btn-info'}
        case 'fulfilled':
          return {icon: 'fa fa-check', style: 'text-teal', btn: 'btn btn-info'}
        case 'cancelled':
        case 'canceled':
          return {icon: 'fa fa-ban', style: 'text-danger', btn: 'btn btn-danger'}
        case 'mp_cancellation':
          return {icon: 'fa fa-ban', style: 'text-danger', btn: 'btn btn-danger'}
        case 'customer_cancellation':
          return {icon: 'fa fa-ban', style: 'text-danger', btn: 'btn btn-danger'}
        case 'returned':
          return {icon: 'fa fa-reply', style: 'text-warning', btn: 'btn btn-warning'}
      }
    }
  },
  watch: {
    transitions() {
      this.transitions.forEach(t => {
        this.$set(this.isLoading, t.date, [])
        t.transitions.forEach(x => {
          this.isLoading[t.date].push(false)
        })
      })
    }
  }
}
</script>
<style scoped>
.text-italics {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/tools/orderHistoryWithComments.vue